<template>
  <BaseSelect
    ref="select"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="mutableLoading"
    :options="mutableOptions"
    @search:focus="onFocus"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </BaseSelect>
</template>

<script>
  import BaseSelect from '@/components/global/base-select';

  export default {
    name: 'LazySelect',

    components: {
      BaseSelect,
    },

    props: {
      source: {
        required: true,
        type: Function,
      },
      autoload: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
    },

    data() {
      return {
        mutableOptions: this.options,
        mutableLoading: this.loading,
      };
    },

    created() {
      if (this.autoload) {
        this.loadOptions();
      }
    },

    methods: {
      onFocus() {
        this.loadOptions();
      },
      loadOptions() {
        if (this.mutableOptions.length > 0 || this.mutableLoading) {
          return;
        }

        this.mutableLoading = true;
        this.source().then((options) => {
          Object.assign(this.$data, {
            mutableLoading: false,
            mutableOptions: options,
          });
        });
      },
    },

    watch: {
      loading(newValue) {
        this.mutableLoading = newValue;
      },
      options(newValue) {
        this.mutableOptions = newValue;
      },
    },
  };
</script>
